<section class="login-section">
    <div class="logo-section">
        <img class="logo" src="assets/images/logo-color.png">
    </div>
    <div class="email-section my-auto">
        <h6>Welcome</h6>
        <!-- <p>sign in entering the information below</p> -->
        <form [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">
            <div class="kg-form-data login-data">
                <div class="form-row">
                    <div class="form-group col-md-12 left-15 mt-0">
                        <label class="label-txt" for="tnumber">Username or Email Address <span class="error">*</span></label>
                        <input floatinput type="text" formControlName="email" class="form-control input" />
                        <span class="bar"></span>
                        <span class="error"
                            *ngIf="loginForm.get('email').touched && loginForm.get('email').errors?.required">
                            Please enter email
                        </span>
                    </div>
                    <div class="form-group col-md-12 left-15 mt-1 mb-0">
                        <label class="label-txt" for="password">Password <span class="error">*</span></label>
                        <input floatinput type="password" formControlName="password" class="form-control input" />
                        <span class="bar"></span>
                        <span class="error"
                            *ngIf="loginForm.get('password').touched && loginForm.get('password').errors?.required">
                            Please enter password
                        </span>
                    </div>
                </div>
                <div class="form-row">
                <div class="form-group col-md-12 left-15 mt-0">
                    <div class="login-remember">
                        <!-- <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck1">
                            <label class="custom-control-label" for="customCheck1">Check this custom checkbox</label>
                          </div> -->
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="defaultCheck1" name="remember_me" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
                            <label class="custom-control-label" for="defaultCheck1">
                                Remember Me
                            </label>
                        </div>
                        <div class="forgot">
                            <a [routerLink]="['/forgot-password']">Forgot password?</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center mt-3 mb-3">
                    <button type="submit" [disabled]="!loginForm.valid" class="btn btn-add mt-2 mb-2 colorblack font14">
                        <span class="fa fa-spinner fa-spin" *ngIf="isLoadingResults"></span>
                        Sign In
                    </button>
                </div>
            </div>
            </div>
        </form>
    </div>

</section>

<!-- <form [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">

    <div class="form-group">
        <label for="email">Email</label>
        <input type="text" formControlName="email" class="form-control" placeholder="Enter email here"
            value="dixita.gohel@beelinesoftwares.com" />
    </div>
    <div class="form-group">
        <label for="password">Password</label>
        <input type="password" formControlName="password" class="form-control" placeholder="Enter password here"
            value="#brevity123" />
    </div>

    <button type="submit" [disabled]="!loginForm.valid">
        <span *ngIf="isLoadingResults"></span>
        Login
    </button>



</form> -->